import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Header from './components/header/header';
import Home from './pages/home';
import Weather from "./pages/weather";
import Footer from './components/footer/footer';
import './app.css';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <div className="app flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/weather" element={<Weather />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </I18nextProvider>

    // <I18nextProvider i18n={i18n}>
    //   <Router>
    //     <div className="app">
    //       <Header />
    //       <main>
    //         <Home />
    //       </main>
    //       <Footer />
    //     </div>
    //   </Router>
    // </I18nextProvider>
  );
}

export default App;